import { graphql, useStaticQuery } from "gatsby";
import { AllProducts } from "../utils/types";

export const useCategories: () => AllProducts = () => {
    const data = useStaticQuery(graphql`
    query {
      allWpCategories {
          nodes {
              id
              data {
                  id
                  link
                  slug
                  name
                  count
              }
            }
        }
    }
  `);

    return data;
};
